/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1GithubInstallAppResponseData = {
  /**
   * The GitHub App install URL. Open it in a browser to install the app and
   *
   * @remarks
   * grant repository access. After installation GitHub returns to Teral, which
   * binds the installation and lands you in the workspace settings.
   */
  url: string;
  /**
   * Unix timestamp in milliseconds after which the URL's signed state expires
   *
   * @remarks
   * and the link must be requested again.
   */
  expiresAt: number;
};

/** @internal */
export const V1GithubInstallAppResponseData$inboundSchema: z.ZodType<
  V1GithubInstallAppResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  url: z.string(),
  expiresAt: z.number().int(),
});

export function v1GithubInstallAppResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1GithubInstallAppResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1GithubInstallAppResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1GithubInstallAppResponseData' from JSON`,
  );
}
